import React from 'react';
import ActivateAccountPage from './pages/ActivateAccountPage/ActivateAccountPage.tsx';
import Backoffice from './pages/Backoffice/Backoffice.tsx';
import { BackofficeInfo } from './pages/BackofficeInfo/BackofficeInfo.tsx';
import { CheckEmail } from './pages/CheckEmail/CheckEmail.tsx';
import LoginPage from './pages/FormPage/LoginPage/LoginPage.tsx';
import PasswordReset from './pages/FormPage/PasswordReset/PasswordReset.tsx';
import PasswordResetRequest from './pages/FormPage/PasswordResetRequest/PasswordResetRequest.tsx';
import SignUpPage from './pages/FormPage/SignUpPage/SignUpPage.tsx';
import Game from './pages/Game/Game.tsx';
import { Home } from './pages/Home/Home.tsx';
import { AddLesson } from './pages/Lessons/AddLesson.tsx';
import { Lessons } from './pages/Lessons/Lessons.tsx';
import SingleLesson from './pages/Lessons/SingleLesson/SingleLesson.tsx';
import { MarketingConsent } from './pages/MarketingConsent/MarketingConsent.tsx';
import { PrivacyPolicy } from './pages/PrivacyPolicy/PrivacyPolicy.tsx';
import { Profil } from './pages/Profil/Profil.tsx';
import { Statistics } from './pages/Statistics/Statistics.tsx';
import { Terms } from './pages/Terms/Terms.tsx';

export const ROUTER = [
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/licytacja',
        element: <Game />,
    },
    {
        path: '/utworz-grupe',
        element: <BackofficeInfo />,
        isPrivate: true,
    },
    {
        path: 'backoffice',
        element: <Backoffice />,
        isPrivate: true,
    },
    {
        path: 'login/activated',
        element: <LoginPage activated={true} />,
    },
    {
        path: 'login',
        element: <LoginPage activated={false} />,
    },
    {
        path: 'signup',
        element: <SignUpPage />,
    },
    {
        path: 'activate-account/:token',
        element: <ActivateAccountPage />,
    },
    {
        path: 'check-email',
        element: <CheckEmail />,
    },
    {
        path: 'profil',
        element: <Profil />,
        isPrivate: true,
    },
    {
        path: 'studenci',
        element: <Statistics />,
        isPrivate: true,
    },
    {
        path: 'nauka',
        element: <Lessons />,
    },
    {
        path: 'dodaj-lekcje',
        element: <AddLesson />,
        isPrivate: true,
    },
    {
        path: ':chosenGroup/lekcja/:titleId',
        element: <SingleLesson />,
    },
    {
        path: 'lekcje/edytuj/:titleId',
        element: <AddLesson />,
        isPrivate: true,
    },
    {
        path: 'regulamin',
        element: <Terms />,
    },
    {
        path: 'polityka-prywatnosci',
        element: <PrivacyPolicy />,
    },
    {
        path: 'marketing',
        element: <MarketingConsent />,
    },
    {
        path: 'password-reset-request',
        element: <PasswordResetRequest />,
    },
    {
        path: 'reset-password/:id',
        element: <PasswordReset />,
    },
];
